module.exports = __webpack_public_path__ + "static/wireframe-online-banking-app-tablet-plp-0878fc8f0559ecfaa0eabddb96c0436f.png";